var map = {
	"./collection.de-CH.json": 1710,
	"./collection.de-DE.json": 1711,
	"./collection.en-CA.json": 1712,
	"./collection.en-GB.json": 1713,
	"./collection.en-IN.json": 1714,
	"./collection.en-ME.json": 1715,
	"./collection.en-US.json": 1716,
	"./collection.es-EM.json": 1717,
	"./collection.es-ES.json": 1718,
	"./collection.fr-BE.json": 1719,
	"./collection.fr-CA.json": 1720,
	"./collection.fr-CH.json": 1721,
	"./collection.nl-BE.json": 1722,
	"./collection.nl-NL.json": 1723,
	"./collection.pl-PL.json": 1724,
	"./collection.pt-BR.json": 1725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1709;